module.exports = __webpack_public_path__ + "static/img/yusbj.6f9a6632.png";